import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';
import useAuthenticatedApi from '@/src/Authentication/components/hooks/useAuthenticatedApi';
import { useEffect, useState } from 'react';

export type LibraryItem = {
    id: string;
    folder: string;
    url: string;
    createdAt: string;
    name: string;
};

export default function useLibrary() {
    const [isLoading, setIsLoading] = useState(true);
    const authenticatedApi = useAuthenticatedApi();
    const { orgId } = useUserOrg();
    const [search, setSearch] = useState('');
    const [library, setLibrary] = useState<LibraryItem[]>([]);
    const [filteredLibrary, setFilteredLibrary] = useState<LibraryItem[]>([]);

    const fetchLibrary = async () => {
        const library = await authenticatedApi.get(`/${orgId}/assets`);
        setLibrary(
            library.data.sort(
                (a: LibraryItem, b: LibraryItem) =>
                    new Date(b.createdAt).getTime() -
                    new Date(a.createdAt).getTime(),
            ),
        );
        setIsLoading(false);
    };

    const resizeAsset = async (
        asset: LibraryItem,
        width: number,
        height: number,
    ) => {
        const response = await authenticatedApi.post(
            `/${orgId}/assets/${asset.id}/resize`,
            JSON.stringify({ width, height }),
        );
        return response.data;
    };

    useEffect(() => {
        setIsLoading(true);

        fetchLibrary();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orgId]);

    useEffect(() => {
        setFilteredLibrary(library);
    }, [library]);

    useEffect(() => {
        const filteredLibrary = library.filter((item) =>
            item.name.toLowerCase().includes(search.toLowerCase()),
        );
        setFilteredLibrary(filteredLibrary);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    return {
        library,
        filteredLibrary,
        isLoading,
        search,
        setSearch,
        fetchLibrary,
        resizeAsset,
    };
}
